const { same } = require('../utils');

exports.computeRotationFromCanvasStateItems = canvasStateItems => same(canvasStateItems, 'rotation');
